var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#0061ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9573 8.73902C18.1872 8.51213 18.2114 8.15783 18.03 7.90411C18.0299 7.89705 18.0291 7.89226 18.0278 7.89049L18.0207 7.8819L18.0174 7.87837L18.0157 7.87661L18.0149 7.87581L18.0136 7.87449L17.9577 7.81903L17.9017 7.76366L17.9003 7.76236L17.8995 7.76157L17.8978 7.75989L17.8942 7.75667L17.8855 7.74962C17.8838 7.74843 17.879 7.74767 17.872 7.74765C17.6167 7.56876 17.2613 7.59266 17.0329 7.81935L17.0328 7.8194L9.99941 14.806L6.96676 11.8164C6.96671 11.8163 6.96665 11.8163 6.9666 11.8162C6.71124 11.563 6.29727 11.563 6.04198 11.8164C5.78608 12.0703 5.78589 12.4823 6.04212 12.7359L6.04234 12.7362L9.53903 16.1829C9.53908 16.1829 9.53912 16.183 9.53917 16.183C9.79249 16.4336 10.2108 16.4336 10.464 16.1829L10.4642 16.1827L17.9573 8.73905C17.9573 8.73904 17.9573 8.73903 17.9573 8.73902ZM18.0129 7.87386L18.0129 7.87383L18.0129 7.87386Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCheckboxChecked);
export default ForwardRef;